import { ConversationModel } from 'Models/ConversationModel';
import { MIN_PARTICIPANTS_TO_ALLOW_LEAVE_GROUP } from 'Constants/env';

/**
 * Returns whether the "Mark as read" / "Mark as unread" option should be shown.
 * True when the feature is enabled, the conversation is not archived, and the user is an active participant.
 */
export const canShowMarkAsReadUnread = (
  conversation: ConversationModel,
  isMarkAsUnreadEnabled: boolean
): boolean =>
  Boolean(
    isMarkAsUnreadEnabled &&
      conversation &&
      !conversation.archived &&
      conversation.isActiveParticipant
  );

/**
 * Returns whether the "Mute notifications" / "Unmute notifications" option should be shown.
 * True when the user is an active participant.
 */
export const canShowMuteUnmute = (conversation: ConversationModel): boolean =>
  Boolean(conversation && conversation.isActiveParticipant);

/**
 * Returns whether the "Leave group" option should be shown.
 * True when the conversation is a group (not SMS), where:
 * - Channel (named group): always true.
 * - Group (ad-hoc group): only if there are more than 2 participants.
 */
export const canShowLeaveGroup = (conversation: ConversationModel): boolean => {
  if (!conversation || conversation.IsSmsConversation) {
    return false;
  }
  switch (conversation.grouping) {
    case 'Channel':
      return true;
    case 'Group':
      return (conversation.participants?.length ?? 0) > MIN_PARTICIPANTS_TO_ALLOW_LEAVE_GROUP;
    default:
      return false;
  }
};
